var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9.5C2 8.94771 1.55228 8.5 1 8.5C0.447715 8.5 0 8.94771 0 9.5V14C0 14.2761 0.223858 14.5 0.5 14.5H13.5C13.7761 14.5 14 14.2761 14 14V9.5C14 8.94771 13.5523 8.5 13 8.5C12.4477 8.5 12 8.94771 12 9.5V12.5H2V9.5ZM3.29289 5.79289C3.68342 5.40237 4.31658 5.40237 4.70711 5.79289L5.99998 7.08577V1.5C5.99998 0.947715 6.4477 0.5 6.99998 0.5C7.55227 0.5 7.99998 0.947715 7.99998 1.5V7.0858L9.29289 5.79289C9.68342 5.40237 10.3166 5.40237 10.7071 5.79289C11.0976 6.18342 11.0976 6.81658 10.7071 7.20711L7.70711 10.2071C7.31658 10.5976 6.68342 10.5976 6.29289 10.2071L3.29289 7.20711C2.90237 6.81658 2.90237 6.18342 3.29289 5.79289Z",
    fill: "#1D386C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.a5563eb3.svg";
export { ForwardRef as ReactComponent };